import React from 'react';
import {CheckRounded} from '@mui/icons-material';

const ConceptCard = ({concept, checked, onChange}) => {
    const handleClick = () => onChange(!checked);

    const handleKeyDown = (e) => {
        if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            onChange(!checked);
        }
    };

    return (
        <div
            role="checkbox"
            aria-checked={checked}
            aria-label={concept.conceptName.replace(/<[^>]*>?/gm, '')}
            tabIndex={0}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            className={`ch-lesson-planner-concept-card${checked ? ' ch-lesson-planner-concept-card--checked' : ''}`}
        >
            <div className={'ch-lesson-planner-concept-card-check'}>
                {checked && <CheckRounded fontSize={'small'} />}
            </div>
            <span className={'ch-lesson-planner-concept-card-name'}>{concept.conceptName}</span>
        </div>
    );
};

export default ConceptCard;
